// 업무상태에 대한 필터 함수를 정의한다.
export default (value) => {
  if (!value) return ''
  const statusArray = [
    { text: '신청', value: 1 },
    { text: '접수', value: 2 },
    { text: '반려', value: 3 }
  ]
  return statusArray.find(s => s.value === value).text
}
